var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 10.09c.05-1.03.94-1.14 1.38-1.07h1.57c.22 0 .64.13.62.67v1.6c-.04.56-.4 1.98-1.48 3.05l-2.99 3.98c-.5.73-1.46 2.95-1.29 6.03a14.66 14.66 0 0 0 1.42 5.91c.5 1.03 1.96 3.46 3.78 4.93h18.94c2.47-1.64 4.5-5.97 5-7.99.76-4.75-.45-7.96-1.15-8.97l-2.98-4.07c-1.19-1.15-1.38-3.01-1.33-3.8-.06-.44.02-1.34.83-1.34H35.55c.81 0 .98.53.95.8l.07.85c.05 1.98.49 3.15.7 3.49l1.54 2.3a16.27 16.27 0 0 1 2.16 7.62c.25 4.38-2.24 8.62-3.51 10.2l-1.26 4.1c-.03.38-.3.42-.48.45h-.05l-3.14.16v-1.75H30.2V39h-2.55v-1.75h-2.38V39h-2.55v-1.75h-2.37V39h-2.56v-1.75h-2.37V39l-3.11-.13c-.42 0-.53-.3-.53-.46l-1.26-4.13c-3.04-4.25-3.26-7.06-3.4-9a25 25 0 0 0-.08-.8c-.17-1.56.4-3.77.71-4.68.29-.96 1.1-3.16 2.06-4.28a6.05 6.05 0 0 0 1.39-2.67 190.86 190.86 0 0 1 .22-1.76l.05-.82v-.17zm10.56 2.46c0-1.08.88-1.96 1.97-1.96 1.09 0 1.97.88 1.97 1.96v10.53c0 1.08-.88 1.96-1.97 1.96a1.97 1.97 0 0 1-1.97-1.96V12.55zM24 32.4c1.09 0 1.97-.88 1.97-1.96s-.88-1.96-1.97-1.96c-1.09 0-1.97.88-1.97 1.96s.88 1.96 1.97 1.96z",
    fill: "#fff"
  }));
});